/**
 * Shared components and utilities for Chat Management Modal
 */

import { parseTimestampMs } from '../../utils/dateTime';

// Shared date formatting utility
export const formatChatDate = (rawdateString: string): string => {
	try {
		const ms = parseTimestampMs(rawdateString);
		if (ms === 0) return 'Unknown date';

		const date = new Date(ms);
		if (Number.isNaN(date.getTime())) return 'Unknown date';

		const dateString = date.toLocaleDateString();
		const timeString = date.toLocaleTimeString([], {
			hour: '2-digit',
			minute: '2-digit',
		});

		return `${dateString} ${timeString}`;
	} catch {
		return 'Unknown date';
	}
};

// Export status message builders
export const buildBulkExportStatusMessage = (result: {
	success: boolean;
	exportedCount: number;
	totalCount: number;
	targetDirectory?: string;
	errors?: string[];
}): string => {
	const hasPartialSuccess = result.exportedCount > 0;

	if (hasPartialSuccess) {
		const directoryPart = result.targetDirectory
			? ` to ${result.targetDirectory}`
			: '';
		const partialText =
			result.exportedCount < result.totalCount ? ' (partial)' : '';
		return `Exported ${result.exportedCount} of ${result.totalCount} chat(s)${partialText}${directoryPart}`;
	}
	return `Export failed: ${result.errors?.[0] || 'Unknown error'}`;
};

// Check if bulk export should be considered successful (even partial)
export const classifyBulkExportResult = (result: {
	exportedCount: number;
	totalCount: number;
}): 'complete_success' | 'partial_success' | 'error' => {
	if (result.exportedCount === 0) {
		return 'error';
	}
	if (result.exportedCount < result.totalCount) {
		return 'partial_success';
	}
	return 'complete_success';
};
